$(document).ready(function() {
    var form = $('form[data-type="add-to-cart-form"]');
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var submitButton = form.find('.custom-shopify-payment-button__button');
    var crossSells = $('.cross-sell-box-section');
    var hideErrors = form.data('hide-errors') === true;

    // Enable form ID field
    form.find('[name=id]').prop('disabled', false);

    // Event listener for the custom shopify payment button
    $(document).on("click", '.custom-shopify-payment-button__button', function(evt) {
        clearCart(evt);
    });

    function clearCart(evt) {
        fetch(window.Shopify.routes.root + 'cart/clear.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(() => {
            onSubmitHandler(evt);
        });
    }

    function onSubmitHandler(evt) {
        evt.preventDefault();
        if (submitButton.attr('aria-disabled') === 'true') return;
        handleErrorMessage();

        submitButton.attr('aria-disabled', true).addClass('loading');
        form.find('.loading__spinner').removeClass('hidden');

        const formData = new FormData(form[0]);
        if (cart) {
            formData.append(
                'sections',
                [].map.call(cart.getSectionsToRender(), (section) => section.id).join(',')
            );
            formData.append('sections_url', window.location.pathname);
            cart.setActiveElement(document.activeElement);
        }

        fetch(`${window.Shopify.routes.root + 'cart/add.js'}`, {
            method: 'POST',
            body: formData
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.status) {
                    throw new Error(response.description || 'Failed to add item to cart');
                }
                return processCrossSells(formData, response);
            })
            .then((response) => {
                window.location.href = '/checkout';
                return;
            })
            .catch((error) => {
                console.error(error);
                handleErrorMessage(error.message);
            })
            .finally(() => {
                submitButton.removeClass('loading');
                if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
                submitButton.removeAttr('aria-disabled');
                form.find('.loading__spinner').addClass('hidden');
            });
    }

    function processCrossSells(formData, response) {
        const selectedCrossSells = crossSells.filter(function() {
            return $(this).find('input[type="checkbox"]').prop('checked');
        }).map(function() {
            return {
                'id': $(this).data('variant-id'),
                'quantity': 1
            };
        }).get();

        if (selectedCrossSells.length === 0) {
            return Promise.resolve(response);
        }

        return fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ items: selectedCrossSells })
        }).then(() => response);
    }

    function handleErrorMessage(errorMessage = false) {
        var errorMessageWrapper = form.find('.product-form__error-message-wrapper');
        var errorMessageText = errorMessageWrapper.find('.product-form__error-message');

        errorMessageWrapper.toggle(!!errorMessage);
        if (errorMessage) {
            errorMessageText.text(errorMessage);
        }
    }
});
